<script setup>
import moment from "moment";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-100 rounded-t-xl overflow-hidden"
          style="min-height: 5vh"
        >
          <div
            style="color: #28293d"
            class="bg-red-100 flex justify-start ml-1 p-1 items-center"
          >
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            <span> Penerbitan CoC </span>
          </div>

          <div
            class="bg-white rounded-t-xl border border-1 shadow-sm p-4 position-relative"
            style="min-height: 60vh"
          >
            <div
              class="container pt-3 pb-3 px-4"
              id="elementPrint1"
              style="border: 4px solid #acacac"
            >
              <div
                class="mt-3 d-flex align-items-center justify-content-between"
              >
                <div
                  class="col-md-6 d-flex"
                  style="
                    padding-left: 2rem;
                    padding-top: 0.5rem;
                    align-items: flex-start;
                  "
                >
                  <img
                    src="../../../assets/images/borneo-indobara-icon.png"
                    alt="logo-borneo-indobara"
                    class="img-fluid"
                    style="width: 13%"
                  />
                  <div style="padding-top: 2%">
                    <h5 class="fw-bold">PT BORNEO INDOBARA</h5>
                  </div>
                </div>

                <img
                  src="../../../assets/logo-sinisaja.png"
                  alt="logo-sini-saja"
                  class="img-fluid"
                  style="width: 10%"
                />
              </div>
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                Certificate of CMS Compliance
              </h1>
              <p
                class="text-center fs-8 mb-3 text-primary fw-bold"
                style="font-family: 'Inter-Regular'"
              >
                Nomor Registrasi : {{ nomorRegistrasi }}
              </p>
              <hr style="margin: 0" />
              <hr
                style="
                  height: 0.25rem;
                  background-color: #000;
                  margin-bottom: 1.1rem;
                  margin-top: 0.25rem;
                "
              />
              <div class="row mb-3">
                <div class="col-md-12">
                  <p class="fs-8">
                    Berdasarkan Elemen Standar BIB-HSE-ES-2.09 tentang
                    Pengelolaan Perusahaan Jasa Pertambangan, PT Borneo Indobara
                    menerbitkan Certificate of CMS Compliance (CoC) kepada :
                  </p>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12">
                  <table class="fs-8 ms-4">
                    <tbody>
                      <tr>
                        <td style="width: 20%">1. Nama Perusahaan Jasa</td>
                        <td>: {{ capitalized(kontraktor?.namaKontraktor) }}</td>
                      </tr>
                      <tr>
                        <td style="width: 20%">2. Kategori Perusahaan</td>
                        <td>: {{ kontraktor.wilayah }}</td>
                      </tr>
                      <tr>
                        <td style="width: 20%">3. Klasifikasi Perusahaan Jasa</td>
                        <td>: {{ kontraktor.jenis }}</td>
                      </tr>
                      <tr>
                        <td style="width: 20%">4. Kualifikasi Perusahaan Jasa</td>
                        <td>
                          :
                          {{
                            kontraktor.kualifikasiUsaha == null
                              ? "-"
                              : kontraktor.kualifikasiUsaha == 1
                              ? "Kecil"
                              : kontraktor.kualifikasiUsaha == 2
                              ? "Sedang"
                              : "Besar"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 20%">5. Kode Klasifikasi Usaha</td>
                        <td>: Lihat Lampiran</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12">
                  <p class="fs-8">
                    Perusahaan Jasa Pertambangan dengan nomor registrasi
                    Certificate of CMS Compliance (CoC) tersebut dapat melakukan
                    persiapan dan/atau pelaksanaan kegiatan berusaha sebagaimana
                    terlampir dengan tetap memperhatikan ketentuan peraturan
                    perundang-undangan dan persyaratan lainnya yang berlaku di
                    wilayah operasional PT Borneo Indobara.
                  </p>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12">
                  <p class="fs-8">
                    Certificate of CMS Compliance (CoC) ini berlaku di seluruh
                    wilayah operasional PT Borneo Indobara dengan masa berlaku 2
                    tahun sejak tanggal diterbitkan. Perusahaan Jasa
                    Pertambangan dapat mengajukan perpanjangan dan/atau
                    pembaharuan Certificate of CMS Compliance (CoC) sesuai
                    dengan ketentuan peraturan yang berlaku di PT Borneo
                    Indobara.
                  </p>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12">
                  <p class="fs-8">
                    Diterbitkan di Angsana, tanggal :
                    {{
                      dataSio.masaBerlaku != null
                        ? moment(dataSio.masaBerlaku)
                            .subtract(2, "Y")
                            .format("DD MMMM yyyy")
                        : moment(new Date()).format("DD MMMM yyyy")
                    }}
                    <br />
                    Berlaku s.d tanggal :
                    {{
                      dataSio.masaBerlaku != null
                        ? moment(dataSio.masaBerlaku).format("DD MMMM yyyy")
                        : moment(new Date()).add(2, "Y").format("DD MMMM yyyy")
                    }}
                    <br /><br />
                    {{ "Perubahan ke-" + dataSio.perubahan }}
                  </p>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-9">&nbsp;</div>
                <div class="col-md-3 text-center mb-1">
                  <p class="mb-1 fs-8">
                    {{
                      dataSio?.updatedAt
                        ? getKepalaTeknikTambangTitle(
                            new Date(dataSio?.updatedAt),
                          )
                        : "Kepala Teknik Tambang"
                    }}
                  </p>
                  <p class="mb-2 fs-8">PT Borneo Indobara</p>
                  <div
                    class="w-100 border border-1 mb-1"
                    style="height: 20vh"
                  ></div>
                  <p class="fs-8" style="position: relative; z-index: 2">
                    {{
                      dataSio?.updatedAt
                        ? getKepalaTeknikTambangName(
                            new Date(dataSio?.updatedAt),
                          )
                        : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="border flex justify-between items-center p-2">
                <ul
                  class="fs-8 pl-5"
                  style="font-family: 'Inter-Regular'; list-style-type: disc"
                >
                  <li>Dokumen ini diterbitkan melalui Aplikasi SINI-SAJA</li>
                  <li>
                    Dalam hal terjadi kekeliruan isi dokumen ini akan dilakukan
                    perbaikan sebagaimana mestinya
                  </li>
                  <li>
                    Pengajuan perpanjangan atau pembaharuan Certificate of CMS
                    Compliance (CoC) diajukan melalui Aplikasi SINI-SAJA
                  </li>
                </ul>
                <img
                  src="../../../assets/logo-sinisaja.png"
                  alt="logo-sini-saja"
                  class="img-fluid"
                  style="width: 10%"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- page2 -->
        <div
          class="mt-3 bg-white rounded-10 w-100 border border-1 shadow-sm p-4 position-relative"
          style="min-height: 60vh"
        >
          <div
            class="container pt-3 pb-3 px-4"
            id="elementPrint2"
            style="border: 4px solid #acacac"
          >
            <div class="mt-3 d-flex align-items-center justify-content-between">
              <div
                class="col-md-6 d-flex"
                style="
                  padding-left: 2rem;
                  padding-top: 0.5rem;
                  align-items: flex-start;
                "
              >
                <img
                  src="../../../assets/images/borneo-indobara-icon.png"
                  alt="logo-borneo-indobara"
                  class="img-fluid"
                  style="width: 13%"
                />
                <div style="padding-top: 2%">
                  <h5 class="fw-bold">PT BORNEO INDOBARA</h5>
                </div>
              </div>

              <img
                src="../../../assets/logo-sinisaja.png"
                alt="logo-sini-saja"
                class="img-fluid"
                style="width: 10%"
              />
            </div>
            <h1 class="text-center mb-3 font-inter font-bold text-3xl">
              LAMPIRAN Certificate of CMS Compliance
            </h1>
            <p
              class="text-center fs-8 mb-3 fw-bold text-primary"
              style="font-family: 'Inter-Regular'"
            >
              Nomor Registrasi : {{ nomorRegistrasi }}
            </p>
            <hr style="margin: 0" />
            <hr
              style="
                height: 0.25rem;
                color: black;
                background-color: black;
                margin-bottom: 1.1rem;
                margin-top: 0.25rem;
              "
            />
            <div class="row mb-3">
              <div class="col-md-12">
                <h3 class="fw-bold">
                  {{ capitalized(kontraktor?.namaKontraktor) }}
                </h3>

                <p class="fs-8">
                  Bidang Usaha Jasa Inti<br />(Memiliki kode KBLI 09900 –
                  Aktivitas Penunjang Pertambangan dan Penggalian Lainnya)
                </p>
                <div class="table-responsive">
                  <table
                    class="table table-striped mb-0"
                    style="width: 100%; font-family: 'Inter-Regular'"
                  >
                    <thead
                      style="
                        font-family: 'Inter-Regular';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 24px;
                        color: #28293d;
                      "
                    >
                      <tr class="table-danger" style="max-height: 5vh">
                        <th class="p-2" style="width: 5%">No.</th>
                        <th class="p-2 pointer text-nowrap" style="width: 10%">
                          Kode KBLI
                        </th>
                        <th class="p-2 pointer text-nowrap" style="width: 15%">
                          Bidang
                        </th>
                        <th class="p-2 pointer text-nowrap" style="width: 35%">
                          Sub-Bidang
                        </th>
                        <th class="p-2 pointer text-nowrap" style="width: 20%">
                          Tingkat Resiko
                        </th>
                        <th class="p-2 pointer text-nowrap" style="width: 15%">
                          Keterangan
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      id="tbody_table_bidang"
                      style="
                        font-family: 'Inter-Regular';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 24px;
                        color: #28293d;
                      "
                    >
                      <tr v-for="(bid, idx) in bidang" :key="idx">
                        <td>{{ idx + 1 }}</td>
                        <td class="text-nowrap">09900</td>
                        <td class="text-wrap">{{ bid.bidang }}</td>
                        <td class="text-wrap">{{ bid.subBidang }}</td>
                        <td class="text-wrap">Tinggi</td>
                        <td class="text-start">
                          <img
                            :src="
                              bid.is_verified
                                ? require('@/assets/icons/verified.png')
                                : require('@/assets/icons/close-64.png')
                            "
                            alt="icon"
                            :style="{
                              width: bid.is_verified ? '6rem' : '4rem',
                              marginLeft: bid.is_verified ? '-0.8rem' : '0',
                            }"
                          />
                        </td>
                      </tr>
                      <tr v-if="!bidang?.length">
                        <td colspan="7" class="text-center">
                          Tidak ada data Bidang
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <p class="fs-8">Bidang Usaha Jasa Non-Inti</p>
                <div class="table-responsive">
                  <table
                    class="table table-striped mb-0"
                    style="width: 100%; font-family: 'Inter-Regular'"
                  >
                    <thead
                      style="
                        font-family: 'Inter-Regular';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 24px;
                        color: #28293d;
                      "
                    >
                      <tr class="table-danger" style="max-height: 5vh">
                        <th class="p-2" style="width: 5%">No.</th>
                        <th class="p-2 pointer text-nowrap" style="width: 10%">
                          Kode KBLI
                        </th>
                        <th class="p-2 pointer text-nowrap" style="width: 30%">
                          Judul KBLI
                        </th>
                        <th class="p-2 pointer text-nowrap" style="width: 10%">
                          Tingkat Resiko
                        </th>
                        <th class="p-2 pointer text-nowrap" style="width: 30%">
                          Kelompok Usaha
                        </th>
                        <th class="p-2 pointer text-nowrap" style="width: 15%">
                          Keterangan
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      id="tbody_table_kbli"
                      style="
                        font-family: 'Inter-Regular';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 24px;
                        color: #28293d;
                      "
                    >
                      <tr v-for="(kb, idx) in kbli" :key="idx">
                        <td>
                          {{ idx + 1 }}
                        </td>
                        <td class="text-wrap">{{ kb.noKbli }}</td>
                        <td class="text-wrap">{{ kb.deskripsi }}</td>
                        <td class="text-wrap">
                          <span v-if="kb.tingkatResiko == 1">Rendah</span>
                          <span v-if="kb.tingkatResiko == 2"
                            >Menengah Rendah</span
                          >
                          <span v-if="kb.tingkatResiko == 3"
                            >Menengah Tinggi</span
                          >
                          <span v-if="kb.tingkatResiko == 4">Tinggi</span>
                        </td>
                        <td class="text-wrap">{{ kb.deskripsiMaster }}</td>
                        <td class="text-wrap">
                          <img
                            :src="
                              kb.isVerified
                                ? require('@/assets/icons/verified.png')
                                : require('@/assets/icons/close-64.png')
                            "
                            alt="icon"
                            :style="{
                              width: kb.isVerified ? '6rem' : '4rem',
                              marginLeft: kb.isVerified ? '-0.8rem' : '0',
                            }"
                          />
                        </td>
                      </tr>
                      <tr v-if="!kbli?.length">
                        <td colspan="6" class="text-center">
                          Tidak ada data Bidang
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!--                    <div class="row mb-3">
                      <div class="col-md-12">
                        <table class="fs-8">
                          <tbody>
                            <tr v-if="perubahan.kontraktor">
                              <td style="width: 20%;">Nama Perusahaan Jasa</td>
                              <td>: {{ capitalized(perubahan?.kontraktor) }}</td>
                            </tr>
                            <tr v-if="perubahan.wilayah">
                              <td style="width: 20%;">Kategori Perusahaan</td>
                              <td>: {{ perubahan.wilayah }}</td>
                            </tr>
                            <tr v-if="perubahan.iujp">
                              <td style="width: 20%;">Klasifikasi Perusahaan Jasa</td>
                              <td>: {{ perubahan.iujp }}</td>
                            </tr>
                            <tr v-if="perubahan.kualifikasiUsaha">
                              <td style="width: 20%;">Kualifikasi Perusahaan Jasa</td>
                              <td>: {{ perubahan.kualifikasiUsaha==null?'-':kontraktor.kualifikasiUsaha==1?'Kecil':kontraktor.kualifikasiUsaha==2?'Sedang':'Besar' }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="table-responsive mb-4" v-if="kbli?.length >= 1">
                        <table class="table table-striped mb-0" style="width: 100%; font-family: 'Inter-Regular'">
                          <thead style="font-family: 'Inter-Regular';font-style: normal;font-weight: 500;font-size: 14px;line-height: 24px;color: #28293D;">
                          <tr class="table-danger" style="max-height: 5vh">
                            <th class="p-2 pointer text-nowrap" style="width: 10%">
                              Kode KBLI
                            </th>
                            <th class="p-2 pointer text-nowrap" style="width: 60%">
                              Deskripsi
                            </th>
                            <th class="p-2 pointer text-nowrap" style="width: 30%">
                              Tingkat Resiko
                            </th>
                          </tr>
                        </thead>
                          <tbody id="tbody_table_kbli" style="font-family: 'Inter-Regular';font-style: normal;font-weight: 500;font-size: 14px;line-height: 24px;color: #28293D;">
                            <tr v-for="(kb,idx) in kbli" :key="idx">
                                <td class="text-wrap">{{ kb.noKbli }}</td>
                                <td class="text-wrap">{{ kb.deskripsi}}</td>
                                <td class="text-wrap">
                                  <span v-if="kb.tingkatResiko==1">Rendah</span>
                                  <span v-if="kb.tingkatResiko==2">Menengah Rendah</span>
                                  <span v-if="kb.tingkatResiko==3">Menengah Tinggi</span>
                                  <span v-if="kb.tingkatResiko==4">Tinggi </span>
                                </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="table-responsive"  v-if="bidang?.length >= 1">
                        <table class="table table-striped mb-0" style="width: 100%; font-family: 'Inter-Regular'">
                          <thead style="font-family: 'Inter-Regular';font-style: normal;font-weight: 500;font-size: 14px;line-height: 24px;color: #28293D;">
                          <tr class="table-danger" style="max-height: 5vh">
                            <th class="p-2 pointer text-nowrap" style="width: 25%">
                              Bidang
                            </th>
                            <th class="p-2 pointer text-nowrap" style="width: 75%">
                              Sub-Bidang
                            </th>
                          </tr>
                          </thead>
                          <tbody id="tbody_table_kbli" style="font-family: 'Inter-Regular';font-style: normal;font-weight: 500;font-size: 14px;line-height: 24px;color: #28293D;">
                            <tr v-for="(kb,idx) in bidang" :key="idx">

                                <td class="text-wrap">{{ kb.bidang }}</td>
                                <td class="text-wrap">{{ kb.subBidang }}</td>
                            </tr>
                            <tr v-if="!bidang?.length">
                              <td colspan="2" class="text-center">Tidak ada data Bidang</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>-->
            <div class="row mb-5 mt-2">
              <div class="col-md-12">
                <ul
                  type="1"
                  class="fs-8 ml-3"
                  style="font-family: 'Inter-Regular'; list-style-type: disc"
                >
                  <li>
                    Syarat dan Ketentuan :
                    <ol
                      type="a"
                      class="fs-8 ml-6"
                      style="font-family: 'Inter-Regular'; list-style-type: lower-alpha;"
                    >
                      <li>
                        Masa berlaku Certificate of CMS Compliance (CoC) selama
                        2 tahun sejak tanggal diterbitkan
                      </li>
                      <li>
                        Certificate of CMS Compliance (CoC) dapat diajukan
                        pembaharuan dengan kondisi :
                      </li>
                      <li>Masa belaku telah habis</li>
                      <li>
                        Terdapat pembaharuan profile perusahaan seperti
                        pembaharuan:
                        <ul
                          type="1"
                          class="fs-8 list-disc ml-8"
                          style="font-family: 'Inter-Regular'"
                        >
                          <li>Nama Perusahaan</li>
                          <li>Kategori Perusahaan</li>
                          <li>Klasifikasi Perusahaan</li>
                          <li>Kualifikasi Perusahaan</li>
                          <li>Kode Klasifikasi Perusahaan</li>
                        </ul>
                      </li>
                      <li>
                        Kepala Teknik Tambang berhak melakukan pencabutan
                        Certificate of CMS Compliance (CoC) jika perusahaan jasa
                        melakukan pelanggaran terhadap persyaratan dan ketentuan
                        yang berlaku di area operasional PT Borneo Indobara
                      </li>
                    </ol>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="border flex items-center justify-between p-2 mb-2 mt-5"
            >
              <ul type="1" class="fs-8 list-disc pl-5" style="font-family: 'Inter-Regular'">
                <li>Dokumen ini diterbitkan melalui Aplikasi SINI-SAJA</li>
                <li>
                  Dalam hal terjadi kekeliruan isi dokumen ini akan dilakukan
                  perbaikan sebagaimana mestinya
                </li>
                <li>
                  Pengajuan perpanjangan atau pembaharuan Certificate of CMS
                  Compliance (CoC) diajukan melalui Aplikasi SINI-SAJA
                </li>
              </ul>
              <img
                src="../../../assets/logo-sinisaja.png"
                alt="logo-sini-saja"
                class="img-fluid"
                style="width: 10%"
              />
            </div>
            <div
              class="d-flex justify-content-end pt-3"
              v-if="
                (dataSio.type == 1 || dataSio.type == 3) &&
                dataSio.status == 7 &&
                dataSio.documentIdSio == null &&
                userData.role.includes('ADMIN')
              "
            >
              <!-- <button class="btn btn-outline-danger w-25 fs-8 fw-bold mb-2" data-bs-toggle="modal" data-bs-target="#updateDataKontraktor">Update Data Kontraktor</button> -->
              <button
                class="btn btn-danger w-25 fs-8 fw-bold mb-2 ms-4"
                @click="clickSimpan(sioID)"
              >
                {{ btnUpdate ? "Update Data Kontraktor" : "Terbitkan" }}
              </button>
            </div>
            <div class="row mb-2" v-else-if="dataSio.type != 3">
              <div
                class="col-md-12 d-inline-flex align-items-end justify-content-end"
                v-if="userData.role.includes('ADMIN')"
              >
                <button
                  class="btn btn_cari w-25 fs-8 fw-bold mb-2"
                  v-if="dataSio.status == 7 && dataSio.documentIdSio == null"
                  @click="clickSimpan(sioID)"
                  style="color: #ffffff"
                >
                  {{ btnUpdate ? "Update Data Kontraktor" : "Terbitkan" }}
                </button>
                <button
                  class="btn btn_cari w-25 fs-8 fw-bold mb-2"
                  v-else-if="
                    dataSio.status == 7 && dataSio.documentIdSio != null
                  "
                  style="color: #ffffff; opacity: 50%"
                >
                  Sedang Dalam Proses Penerbitan Certificate of CMS Compliance
                  (CoC)
                </button>
                <a
                  class="btn btn_cari w-25 fs-8 fw-bold mb-2"
                  v-if="dataSio.status == 3"
                  style="color: #ffffff"
                  @click="downloadFileEsign(dataSio.documentIdSio)"
                  >Download Dokumen Certificate of CMS Compliance (CoC)</a
                >
              </div>
            </div>
            <div class="row mb-2" v-else>
              <div
                class="col-md-12 d-inline-flex align-items-end justify-content-end"
                v-if="userData.role.includes('ADMIN')"
              >
                <button
                  class="btn btn_cari w-25 fs-8 fw-bold mb-2"
                  v-if="dataSio.status == 2 && dataSio.documentIdSio == null"
                  @click="clickSimpan(sioID)"
                  style="color: #ffffff"
                >
                  {{ btnUpdate ? "Update Data Kontraktor" : "Terbitkan" }}
                </button>
                <button
                  class="btn btn_cari w-25 fs-8 fw-bold mb-2"
                  v-else-if="
                    dataSio.status == 2 && dataSio.documentIdSio != null
                  "
                  style="color: #ffffff; opacity: 50%"
                >
                  Sedang Dalam Proses Penerbitan Certificate of CMS Compliance
                  (CoC)
                </button>
                <a
                  class="btn btn_cari w-25 fs-8 fw-bold mb-2"
                  v-if="dataSio.status == 3"
                  style="color: #ffffff"
                  @click="downloadFileEsign(dataSio.documentIdSio)"
                  >Download Dokumen Certificate of CMS Compliance (CoC)</a
                >
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- &lt;!&ndash; You can customize the loading content here (e.g., a spinner) &ndash;&gt; -->
    <div>
      <img
        src="@/assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
  <!-- modal filter -->
  <div
    class="modal fade"
    id="updateDataKontraktor"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Evaluasi Penerbitan CoC</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModal"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <p class="text-secondary fs-8">
            Masukkan Catatan Evaluasi <b>Penerbitan CoC</b> pada kolom dibawah
            ini
          </p>
          <!--          <p class="text-secondary fs-8"><span class="text-danger fw-bold">*</span> Tipe pengajuan CoC ini akan diubah menjadi <b>Update data CoC</b></p>-->
          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold"
                  >Catatan</label
                >
              </div>
              <textarea
                class="form-control fs-8"
                id="exampleFormControlTextarea1"
                rows="7"
                v-model="reason"
                placeholder="Masukkan catatan mengapa kontraktor perlu diubah"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="updateDataKontraktor()"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../../GlobalDataMixin";
// import Datepicker from "vuejs3-datepicker"
import axios from "axios";
import Swal from "sweetalert2";
import {
  API_BASE_URL,
  CMS_DOWNLOAD_ESIGN,
  CMS_GET_CHANGES_LIST,
  CMS_GET_DETAILKONTRAKTOR,
  // CMS_VIEW_IMAGE,
  CMS_GET_SIOID,
  CMS_SET_STATUS_SIO,
  CMS_SIO_SET_SIOPENGESAHAN,
  // CMS_SET_SIOID
} from "@/constants";
//import Swal from "sweetalert2"
import printJS from "print-js";
import router from "@/router";
import { capitalized } from "@/utilities/helpers";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  getKepalaTeknikTambangName,
  getKepalaTeknikTambangTitle,
} from "@/config/tempKepalaTeknikTambang";

// const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;

const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
// const url_set_sioid = API_BASE_URL + CMS_SET_SIOID;
const url_detail_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_set_pengesahan_sio = API_BASE_URL + CMS_SIO_SET_SIOPENGESAHAN;
const url_get_changes_list = API_BASE_URL + CMS_GET_CHANGES_LIST;
const url_set_sio_status = API_BASE_URL + CMS_SET_STATUS_SIO;
const url_download_esign = API_BASE_URL + CMS_DOWNLOAD_ESIGN;

export default {
  mixins: [GlobalDataMixin],
  name: "lihatDokumenSIO",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
  },
  data() {
    return {
      isPrint: false,
      isLoading: true,
      sioID: null,
      kontraktorName: null,
      kontraktorid: null,
      id: null,
      formValues: {
        namaPemimpin: "",
        jabatanPemimpin: "",
        nama: "",
        perusahaan: "",
        jabatan: "",
        kompetensi: "",
        noSertifikat: "",
        pjo: "",
        tempat: "",
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        tandaTangan: "",
        namaTTD: "",
        ttd: "",
      },
      kontraktor: [],
      bidang:[],
      kbli:[],
      kbli_inti:[],
      dataSio:[],
      nomorRegistrasi:'',
      downloadUrlSio: null,
      type: null,
      perubahan: {
        kontraktor: null,
        wilayah: null,
        iujp: null,
        kualifikasiUsaha: null,
        bidang: [],
        kbli: [],
      },
      reason: null,
      btnUpdate: false,
    };
  },
  mounted() {
    this.sioID = this.$route.params.id;
    this.kontraktorid = this.$route.params.kontraktorid;
    this.getSioID(this.kontraktorid);
    this.fetchDataKontraktor(this.kontraktorid);
    this.getChangesList(this.kontraktorid);
  },
  methods: {
    capitalized,
    getKepalaTeknikTambangName,
    getKepalaTeknikTambangTitle,
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response nya = ", response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let dt = null;
          dt = response.data.data;
          if (dt != null) {
            this.dataSio = dt;
            this.sioID = dt.id;

            // let id = '';
            // if(dt.id<10){
            //   id = '00'+dt.id
            // }else if(dt.id<100){
            //   id = '0'+dt.id;
            // }else{
            //   id = dt.id
            // }

            // this.nomorRegistrasi = 'BIB-CoC-A-'+id;
            // localStorage.setItem('sio_cms',JSON.stringify({'id':dt.id}));
            // this.getSioDashboard(this.sioID);
            this.status = dt.status;
            this.downloadUrlSio = dt.downloadUrlSio;
            this.type = dt.type;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    fetchDataKontraktor(id) {
      axios
        .get(url_detail_kontraktor + id)
        .then((response) => {
          this.kontraktor = response.data.detailKontraktor;

          this.kontraktorName = this.capitalized(
            response.data.detailKontraktor.namaKontraktor
          );
          var arr_kbli = [];
          var arr_kbli_inti = [];
          let kode = this.kontraktor.isSubKontraktor ? 'B' : 'A';
          this.nomorRegistrasi = this.dataSio.sioNumber != null ? this.dataSio.sioNumber : 'BIB-CoC-' + kode + '-Generate by System';
          let dtkb = response.data.dataKbli;
          for (var kk in dtkb) {
            if (dtkb[kk].noKbli != "09900" && dtkb[kk].noKbli != "9900") {
              arr_kbli.push(dtkb[kk]);
            } else if (dtkb[kk].noKbli == '09900' || dtkb[kk].noKbli == '9900'){
              arr_kbli_inti.push(dtkb[kk])
            }
          }
          this.kbli = arr_kbli;
          this.kbli_inti = arr_kbli_inti;

          var arr_bid = [];
          for (var key in this.kontraktor.bidang) {
            var subi = this.kontraktor.bidang[key];

            for (var xx in subi) {
              if (
                key != "" &&
                key != null &&
                subi[xx] != "" &&
                subi[xx] != null
              ) {
                arr_bid.push({
                  bidang: key,
                  subBidang: subi[xx].split("-")[0],
                  is_verified: JSON.parse(subi[xx].split("-")[1]),
                  notes:
                    subi[xx].split("-")[2] === "null"
                      ? null
                      : subi[xx].split("-")[2],
                });
              }
            }
          }
          this.bidang = arr_bid;
          // handle jika kbli / bidang ada yang is_verified false
          let kbli = this.kbli.filter(item => item.isVerified === false || item.is_verified === null);
          let bidang = this.bidang.filter(item => item.is_verified === false || item.is_verified === null);
          let kbli_inti = this.kbli_inti.filter(item => item.isVerified === false || item.isVerified === null)
          if (kbli_inti.length > 0 || kbli.length > 0 || bidang.length > 0 || (this.kontraktor?.jenis === "Inti" && this.kontraktor.bidang[""]) || dtkb.length === 0) {
            this.btnUpdate = true;
          }
        })
        .catch((error) => {
          alert("Error Fetch Data List Kontraktor : " + error.message);
        });
    },
    print() {
      printJS({
        printable: "elementPrint", // ID of the element you want to print
        // printable : ['elementPrint1','elementPrint2'],
        type: "html", // 'html' or 'image'
        // header: 'Print Preview', // optional
        documentTitle: "DokumenSIO", // optional
      });
    },
    printSIO() {
      // this.$router.push('/printDokumenSIO/'+this.sioID+'/'+this.kontraktorid)
      window.open(
        "/printDokumenSIO/" + this.sioID + "/" + this.kontraktorid,
        "_blank"
      );
      // this.isPrint = true;
      // this.isLoading = true;
      // this.print();
      // setTimeout(this.print(),2000)
      // this.isLoading = true;
      // let bodyJson = {
      //   kontraktorId: this.clicked.kontraktorId,
      //   action: "publish-sio",
      //   id: this.clicked.idSio
      // }
      // axios
      //     .post(url_set_sioid, bodyJson, {
      //       headers: {
      //         role:'isafe',
      //         Authorization: "Bearer " + this.userData.token,
      //         accept: "application/json",
      //       },
      //     })
      //     .then((response) => {

      //       console.log("response terbitSIO : ", response)
      //       this.alertSukses()
      //       this.isLoading = false;
      //     })
      //     .catch((error) => {
      //       this.isLoading = false;
      //       console.log("error terbitSIO : ", error)
      //       alert("error terbitSIO")
      //     })
      //     .then(() => {})
    },
    alertSukses() {
      Swal.fire({
        title: "Berhasil",
        text: "Berhasil simpan!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$refs.closeModal.click();
        // this.$router.back()
        // this.$router.go()
        router.push("/approval-sio");
      });
    },
    printDokumen() {
      const printableContent = document.getElementById("templatex");
      const printWindow = window.open("", "_blank");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Dokumen CoC</title>
              <style>
                /* Add your print styles here */
                body {
                  font-family: Inter-Regular;
                }
              </style>
            </head>
            <body>
              ${printableContent.innerHTML}
            </body>
          </html>cms-backend-c5f7bbf5f-jqvvm<
        `);

        printWindow.document.close();
        printWindow.print();
      } else {
        console.error("Failed to open print window.");
      }
    },
    clickSimpan(sioID) {
      if (this.btnUpdate) {
        this.$router.push(
          "/verifikasiDataKontraktorPenerbitan/" +
            sioID +
            "/" +
            this.kontraktorid
        );
      } else {
        Swal.fire({
          title: "Simpan Pengesahan CoC",
          text: "Apakah anda yakin akan menyimpan data pengesahan ini ?",
          icon: "warning",
          showCancelButton: true,
          showConfirmButton: true,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.isLoading = true;
            this.pengesahanSio(sioID);
          }
        });
      }
    },
    pengesahanSio(sioID) {
      let dateNow =
        this.dataSio.masaBerlaku != null
          ? moment(this.dataSio.masaBerlaku)
              .subtract(2, "Y")
              .format("DD MMMM yyyy")
          : moment(new Date()).format("DD MMMM yyyy");
      let datePlusTwoYear =
        this.dataSio.masaBerlaku != null
          ? moment(this.dataSio.masaBerlaku).format("DD MMMM yyyy")
          : moment(new Date()).add(2, "Y").format("DD MMMM yyyy");
      let bodyJson = {
        idSio: sioID,
        tanggal: dateNow,
        masaBerlaku: datePlusTwoYear,
      };
      axios
        .post(url_set_pengesahan_sio, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response saveSuratSio ==> ", response);
          window.location.reload();
        })
        .catch((error) => {
          console.log("error saveSuratSio: ", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan saat simpan pengesahan CoC!",
          });
          this.isLoading = false;
        });
    },
    getChangesList(id) {
      let bodyJson = {
        kontraktorId: id,
      };
      axios
        .post(url_get_changes_list, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("getChangesList => ", response);
          let kontraktor = response.data.dataChanges;
          let bidang = kontraktor.bidangUsahaGems;

          this.perubahan.kontraktor = kontraktor.namaKontraktor;
          this.perubahan.wilayah =
            kontraktor.provinsi == "Kalimantan Selatan"
              ? "Local"
              : kontraktor.provinsi == null
              ? null
              : "Non Local";
          this.perubahan.iujp = kontraktor.iujp;
          this.perubahan.kualifikasiUsaha = kontraktor.kualifikasiUsaha;

          this.perubahan.kbli = kontraktor.kblis;
          this.perubahan.bidang = JSON.parse(bidang);
        })
        .catch((error) => {
          console.log("error getChangesList => ", error);
        });
    },
    updateDataKontraktor() {
      Swal.fire({
        title: "Konfirmasi",
        text: "Apakah yakin, kontraktor harus mengupdate profile perusahaan?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#198754",
        cancelButtonColor: "#dd3737",
        confirmButtonText: "Ya!",
        cancelButtonText: "Batal",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          let bodyJson = {
            status: 8,
            id: this.sioID,
            reason: this.reason,
            type: 1,
            history: "update",
          };

          axios
            .post(url_set_sio_status, bodyJson, {
              headers: {
                role: "isafe",
                Authorization: "Bearer " + this.userData.token,
                accept: "application/json",
              },
            })
            .then(() => {
              this.alertSukses();
            })
            .catch((error) => {
              console.log(error);
              this.isLoading = false;
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Terjadi kesalahan saat evaluasi penerbitan CoC!",
              });
            });
        }
      });
    },
    downloadFileEsign(id) {
      this.isLoading = true;
      let filename = `File CoC ${this.kontraktorName}.zip`;
      axios
        .get(url_download_esign, {
          params: { id: id },
          headers: {
            role: this.userData.role,
            Authorization: `Bearer ${this.userData.token}`,
            Accept: "application/json",
          },
          responseType: "blob", // Ensure binary data handling
        })
        .then((response) => {
          if (response.status !== 200) {
            throw new Error("Network response was not ok");
          }
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); // Use the filename from the header or default one
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url); // Clean up the URL object
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error downloading file:", error);
        });
    },
  },
};
</script>

<style scoped>
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

.btn_eform {
  background-color: #fff;
  border: #d0d5dd;
}

#elementPrint1::after,
#elementPrint2::after {
  content: "";
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  right: 0.5rem;
  bottom: 0.5rem;
  width: auto;
  height: auto;
  margin: 1.4rem;
  border: 2px solid #acacac;
  pointer-events: none;
}
</style>
